var map = {
	"./file_place_holder.png": "4b33",
	"./hellow_event.png": "c452",
	"./hellow_profile.png": "bbd7",
	"./iphone.png": "c4cb",
	"./iphone_no_clock.png": "9c1b",
	"./layout.png": "b5a9",
	"./logo.png": "cf05",
	"./photo.png": "f6f0",
	"./Онбордингgevfacwd.png": "70e1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";